import { initI18n, getLocale } from '@tencent/iegsp-common/i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

// 仅本地维护的词条（含业务数据的品类说明），不进主语言包、不上词条平台，代码级注入
const LOCAL_ONLY_MESSAGES = {
  'zh-CN': {
    '素材类包含2D&平面、3D&动效、视频、网媒、音频。': '素材类包含2D&平面、3D&动效、视频、网媒、音频。',
    '素材类包含2D&平面、3D&动效、设计制作、网媒、音频。': '素材类包含2D&平面、3D&动效、设计制作、网媒、音频。',
    '项目类包含研发项目外包、市场与用户研究、翻译及本地化。': '项目类包含研发项目外包、市场与用户研究、翻译及本地化。',
  },
  'en-US': {
    '素材类包含2D&平面、3D&动效、视频、网媒、音频。':
      'Asset-type includes 2D Art, 3D Art, Video Production, Website Design, and Audio.',
    '素材类包含2D&平面、3D&动效、设计制作、网媒、音频。':
      'Asset-type include 2D Art, 3D Art, design and production, website design, and audio.',
    '项目类包含研发项目外包、市场与用户研究、翻译及本地化。':
      'Project Type include R&D project outsourcing, market & user research, and translation and localization.',
  },
};

Object.assign(messages['zh-CN'], LOCAL_ONLY_MESSAGES['zh-CN']);
Object.assign(messages['en-US'], LOCAL_ONLY_MESSAGES['en-US']);

initI18n(messages);

if (getLocale() === 'zh-CN') {
  document.title = '供应商门户';
}
